export const orderSubmitActions = {
  orderSubmit: 'ORDERSUBMIT',
  validateCalendar: 'VALIDATEINSTALL',
  getCalendar: 'GETCALENDAR'
}

export const cbmEligibilityTypes = {
  notEligible: 'NOT_ELIGIBLE',
  taxExemptEligible: 'ELIGIBLE_TAX_EXEMPT',
  noInternetEligible: 'ELIGIBLE_NO_INTERNET',
  noEligibleLob: 'NO_ELIGIBLE_LOB',
  eligible: 'ELIGIBLE',
  addedCBM: 'ADDED_CBM',
  hasCbm: 'HAS_CBM',
  notEligibleEC: 'NOT_ELIGIBLE_EC',
  notEligibleActiveCbm: 'NOT_ELIGIBLE_ACTIVE_CBM'
}

export const cbmStatusTypes = {
  isEligible: 'isEligible',
  notEligible: 'notEligible',
  hasCbm: 'hasCbm',
  taxExemptEligible: 'taxExemptEligible'
}

const ELIGIBLE_TAX_EXEMPT = {
  messages: [
    'Tax Exempt Customers are not eligible for Comcast Business Mobile.'
  ],
  messageType: 'warning'
}

const ADDED_CBM = {
  messages: [
    "To finish submitting the customer's CBM order, select Launch CBM below."
  ],
  messageType: 'success'
}

export const cbmMessages = {
  ELIGIBLE: {
    configure: {
      messages: ['Customer qualifies for CBM.'],
      messageType: 'success'
    }
  },
  ELIGIBLE_NO_INTERNET: {
    configure: {
      messages: [
        'Customer meets the criteria for CBM eligibility. Return to PEO Page to select an offer with Business Internet to add CBM to the order.'
      ],
      messageType: 'warning'
    },
    documents: {
      messages: [
        'Customer meets the criteria for CBM eligibility. Business Internet is required to add CBM to the order.'
      ],
      messageType: 'warning'
    }
  },
  NO_ELIGIBLE_LOB: {
    configure: {
      messages: [
        'Customer meets the criteria for CBM eligibility. Return to PEO Page to select an offer with Business Internet, Voice, or TV to add CBM to the order.'
      ],
      messageType: 'warning'
    },
    documents: {
      messages: [
        'Customer meets the criteria for CBM eligibility. Business Internet, Voice, or TV is required to add CBM to the order.'
      ],
      messageType: 'warning'
    }
  },
  NOT_ELIGIBLE_EC: {
    offers: {
      messages: ['You must select an offer with Business Internet to enable CBM quoting for this order.'],
      messageType: 'warning'
    }
  },
  NOT_ELIGIBLE_ACTIVE_CBM: {
    offers: {
      messages: ['Customer has active Comcast Business Mobile services.'],
      messageType: 'warning'
    }
  },
  ELIGIBLE_TAX_EXEMPT: {
    offers: ELIGIBLE_TAX_EXEMPT,
    configure: ELIGIBLE_TAX_EXEMPT,
    documents: ELIGIBLE_TAX_EXEMPT,
    submit: ELIGIBLE_TAX_EXEMPT,
    success: null,
    dashboard: null
  },
  ADDED_CBM: {
    submit: ADDED_CBM,
    documents: null,
    success: null,
    dashboard: null
  }
}
export const banErrorMessage = 'BAN could not be fetched due to application error, please proceed with manual process or try again later'
export const banNotFoundMessage = 'BAN could not be found, please confirm existing BAN'
export const voiceLineMisMatchErrorCode = 'COMMERCIALSVC-0007'

// CBM Eligibility Messages
export const cbmEligibilityMessages = {
  notEligibleCriteria: 'Customer does not meet the criteria for CBM eligibility.',
  taxExemptNotEligible: 'Tax Exempt Customers are not eligible for Comcast Business Mobile.',
  needsInternetOnOffers: 'Customer meets the criteria for CBM eligibility. Select an offer with Business Internet to add CBM to the order.',
  needsInternetOnConfigure: 'Customer meets the criteria for CBM eligibility. Return to PEO Page to select an offer with Business Internet to add CBM to the order.',
  needsInternetOnDocuments: 'Customer meets the criteria for CBM eligibility. Return to PEO Page to select an offer with Business Internet to add CBM to the order.',
  selectFiltersToEnable: 'Go back to PEO page and select any filter to enable CBM',
  needsEligibleLobOnOffers: 'Customer meets the criteria for CBM eligibility. Select an offer with Business Internet, Voice, or TV to add CBM to the order.',
  needsEligibleLobOnConfigure: 'Customer meets the criteria for CBM eligibility. Return to PEO Page to select an offer with Business Internet, Voice, or TV to add CBM to the order.',
  needsEligibleLobOnDocuments: 'Customer meets the criteria for CBM eligibility. Return to PEO Page to select an offer with Business Internet, Voice, or TV to add CBM to the order.'
}